import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { sanitizeContent } from 'utilities/comments';

import { useGetWorkspaceTeamMembers } from 'hooks/workspace';

import MentionPill from '../mention-pill';
import { replaceMentionsInContent } from '../../../../../shared/utilities/mention';

const FILTERED_OUT_PROPS = ['workspaceTeamMembers', 'withPills', 'content'];
const MentionParser = props => {
  const { withPills, comment } = props;
  const workspaceTeamMembers = useGetWorkspaceTeamMembers();

  const getSanitizedAndMentionedContent = comment => {
    const sContent = sanitizeContent(comment);

    const displayMention = ({ displayName, modelId }) => {
      const teamMember =
        workspaceTeamMembers &&
        workspaceTeamMembers.find(
          member => String(member.id) === String(modelId)
        );

      const finalDisplayName = teamMember
        ? `${teamMember.first_name} ${teamMember.last_name}`
        : displayName;

      return withPills
        ? ReactDOMServer.renderToString(
            <MentionPill>{finalDisplayName}</MentionPill>
          )
        : finalDisplayName;
    };

    return replaceMentionsInContent(sContent, displayMention);
  };

  const filteredProps = Object.keys(props)
    .filter(k => !FILTERED_OUT_PROPS.includes(k))
    .reduce((newProps, key) => ({ ...newProps, [key]: props[key] }), {});

  return (
    <div
      {...filteredProps}
      dangerouslySetInnerHTML={{
        __html: getSanitizedAndMentionedContent(comment),
      }}
    />
  );
};

export default MentionParser;
